module.exports = __webpack_public_path__ + "img/slider-foto8.6459f46f.png";